import { TierartEnum } from '@ps20-frontend/frontend-models';
import { ProdukttabelleEnum } from './payload-models/produktRequested';

export function determineTkvV2Produkttabelle(tierart: TierartEnum, isVollschutz: boolean): ProdukttabelleEnum {
  switch (tierart) {
    case TierartEnum.KATZE:
      return isVollschutz ? ProdukttabelleEnum.TKV_V2_KATZE_VOLLSCHUTZ : ProdukttabelleEnum.TKV_V2_KATZE_OPSCHUTZ;
    case TierartEnum.PFERD:
      return isVollschutz ? ProdukttabelleEnum.TKV_V2_PFERD_VOLLSCHUTZ : ProdukttabelleEnum.TKV_V2_PFERD_OPSCHUTZ;
    case TierartEnum.HUND:
    default:
      return isVollschutz ? ProdukttabelleEnum.TKV_V2_HUND_VOLLSCHUTZ : ProdukttabelleEnum.TKV_V2_HUND_OPSCHUTZ;
  }
}
